import { Store } from "../redux/store";
import { showWarning, showSuccess } from '../redux/actions/snackbarActions'
import { post, handleErrors, get } from "./requests";
import { URL_BASE } from "./constants";
import { loadGroups, loadMessages } from "../redux/actions/whatsappActions";

async function sendMessage(body, toAll, destinations, category, subcategory, file, destinationsGroups) {
    const formData = new FormData();
    formData.append('body', body);
    formData.append('sendToAllUsers', toAll);
    formData.append('file', file);
    formData.append('destinations', destinations);
    formData.append('category', category);
    formData.append('subcategory', subcategory);
    formData.append('groups', destinationsGroups);  
    const token = Store.getState().authState.loggedUser;
    await post(`${URL_BASE}/whatsapp`, formData, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }, (error) => {
        const { status, data } = error;
        handleErrors(status, data);
    });

    Store.dispatch(showSuccess("Message sended successfully!"));
    return;
}

async function getAllGroups(setGroups) {
    try {
        const url = `${URL_BASE}/whatsapp/groups`;
        const response = await get(url);
        const groupsData = response.data.map(group => ({ value: group.id, display: group.name }));
        setGroups(groupsData);
        Store.dispatch(loadGroups(groupsData));
        return groupsData;
    } catch (error) {
        // Tratar erros aqui, se necessário
        console.error('Error fetching groups:', error);
        return [];
    }
}

export async function getWhatsappMessages(category, subcategory, allUsers, search, pageIndex = 0, pageSize = 10) {
    try {
      let url = `${URL_BASE}/whatsapp?pageIndex=${pageIndex}&pageSize=${pageSize}`;
  
      if (category) {
        url += `&category=${category}`;
      }
      if (subcategory) {
        url += `&subcategory=${subcategory}`;
      }
      if (allUsers !== null) {
        url += `&allUsers=${allUsers}`;
      }
      if (search) {
        url += `&search=${search}`;
      }
  
      const response = await get(url);
      const mappedMessages = response.data.items.map(item => ({
        id: item.id,
        urlFile: item.urlFile,
        body: item.body,
        category: item.category,
        subcategory: item.subcategory,
        sendToAllUsers: item.sendToAllUsers,
        destinations: item.destinations,
        creationDate: item.creationDate
      }));
      return mappedMessages;
    } catch (error) {
      throw error;
    }
  }
  

export default {
    sendMessage,
    getAllGroups,
    getWhatsappMessages
}